module.exports = __webpack_public_path__ + "static/media/EE-logo-2022.8ec7fb1c.png";